import React from 'react'
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {PoView} from './Billing'
import {PaymentMethodView} from './PayMethodView'
import {CreditNoteView} from './CreditNoteView'
import {CashBalanceView} from './CashBalanceView'

import { ADMIN_ROLE } from '../../constants'
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/user';
import { bindActionCreators } from 'redux';

function mapStateToProps(state) {
    return {
        userRoles: state.user.userRoles

    };
}

function mapDispatchToProps(dispatch) {
    return {}
}



const paperStyle = {
    marginTop: 100,
    paddingBottom: 50,
    paddingTop: 25,
    padding: 20,
    width: '100%',
    textAlign: 'left',
    display: 'inline-block',
};


@connect(mapStateToProps, mapDispatchToProps)
class BillingView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false,
            tab: 0,

        }
        this.handleClick = this.handleClick.bind(this);
        this.changeTab = this.changeTab.bind(this);
    }


    handleClick(e) {
        this.setState({ open: true });
    }



    changeTab(event, value) {
        this.setState({ tab: value });
    }


    render() {
        const isAdmin = this.props.userRoles.includes(ADMIN_ROLE)
        return (
            <Paper style={paperStyle}>
                <Tabs
                    value={this.state.tab}
                    onChange={this.changeTab}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Nueva Facturacion" />
                    <Tab label="Notas de Credito" />
                    <Tab label="Caja" />
                    {isAdmin &&<Tab label="Medios de Pago" />}
                    {/* <Tab label="Anulacion Facturacion" /> */}
                </Tabs>
                {this.state.tab === 0 && <PoView />}
                {this.state.tab === 1 && <CreditNoteView />}
                {this.state.tab === 2 && <CashBalanceView />}
                {this.state.tab === 3 && <PaymentMethodView />}
                 
            </Paper>

        )
    }
}

export default BillingView


// WEBPACK FOOTER //
// ./src/components/Billing/BillingView.js